import type { ComponentProps } from "react";
import { cn } from "./button";

export function DashboardLayout({
  className,
  ...props
}: ComponentProps<"div">) {
  return (
    <div
      data-slot="dashboard"
      className={cn(
        "dashboard-shell flex h-dvh w-full gap-[11px] bg-tray p-2 text-ink max-[640px]:gap-0 max-[640px]:p-1.5",
        className,
      )}
      {...props}
    />
  );
}
export function DashboardSidebar({
  className,
  collapsed,
  ...props
}: ComponentProps<"aside"> & { collapsed?: boolean }) {
  return (
    <aside
      data-slot="sidebar"
      className={cn(
        "dashboard-sidebar flex min-h-0 w-[231px] shrink-0 flex-col gap-2 rounded-2xl border border-black/10 bg-card p-2 shadow-surface transition-[width] duration-200 max-[900px]:w-[210px] max-[640px]:hidden motion-reduce:transition-none",
        collapsed && "w-[58px] max-[900px]:w-[58px]",
        className,
      )}
      {...props}
    />
  );
}
export function DashboardMain(props: ComponentProps<"div">) {
  return (
    <div
      data-slot="main"
      className="flex min-h-0 min-w-0 flex-1 flex-col"
      {...props}
    />
  );
}
export function DashboardPanel({ className, ...props }: ComponentProps<"div">) {
  return (
    <div
      data-slot="panel"
      className={cn(
        "dashboard-panel relative min-h-0 flex-1 overflow-auto rounded-2xl border border-black/10 bg-card shadow-surface max-[640px]:rounded-[13px]",
        className,
      )}
      {...props}
    />
  );
}
